import {
  V2PollInstanceState,
  V2TriggerInstanceState,
  type V2PollInstance,
  type V2TriggerInstance,
} from '@/generated/hooks/bdk/models';
import type { V1AutomationTrigger } from '@/generated/hooks/grimoire/models';

/** Trigger type constants */
export const TRIGGER_TYPE = {
  WEBHOOK: 'webhook',
  EMAIL: 'email',
  POLL: 'poll',
} as const;

export type TTriggerType = (typeof TRIGGER_TYPE)[keyof typeof TRIGGER_TYPE];

/** Trigger status type constants */
export const TRIGGER_STATUS = {
  ACTIVE: 'active',
  ERROR: 'error',
  PAUSED: 'paused',
  PENDING: 'pending',
} as const;

export type TTriggerStatus =
  (typeof TRIGGER_STATUS)[keyof typeof TRIGGER_STATUS];

/**
 * Gets the trigger status from a trigger instance state.
 *
 * @param triggerInstance - The trigger or poll instance to get status from
 * @param grimoireTrigger - The grimoire trigger to check if active
 * @returns The trigger status (active, pending, paused, or error)
 */
export const getTriggerStatus = (
  triggerInstance: V2TriggerInstance | V2PollInstance,
  grimoireTrigger: V1AutomationTrigger,
): TTriggerStatus => {
  if (!grimoireTrigger.is_active) {
    return TRIGGER_STATUS.PAUSED;
  }
  const state = triggerInstance.status?.state;
  if (
    state === V2TriggerInstanceState.TRIGGER_INSTANCE_STATE_READY ||
    state === V2PollInstanceState.POLL_INSTANCE_STATE_READY
  ) {
    return TRIGGER_STATUS.ACTIVE;
  }
  if (
    state === V2TriggerInstanceState.TRIGGER_INSTANCE_STATE_FAILED ||
    state === V2PollInstanceState.POLL_INSTANCE_STATE_FAILED
  ) {
    return TRIGGER_STATUS.ERROR;
  }
  return TRIGGER_STATUS.PENDING;
};
